"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUrl = exports.validateEmail = exports.validateDateOfBirthday = void 0;
function validateDateOfBirthday(date) {
    const regexp = new RegExp('^\\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$');
    if (date && !regexp.test(date)) {
        return 'Date of birth must be "YYYY-MM-DD"';
    }
    else {
        return null;
    }
}
exports.validateDateOfBirthday = validateDateOfBirthday;
function validateEmail(email) {
    const regexp = new RegExp('^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$');
    if (email && !regexp.test(email)) {
        return 'Invalid email';
    }
    else {
        return null;
    }
}
exports.validateEmail = validateEmail;
function validateUrl(email) {
    const regexp = new RegExp('(https:\\/\\/www\\.|http:\\/\\/www\\.|https:\\/\\/|http:\\/\\/)?[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})(\\.[a-zA-Z]{2,})?\\/[a-zA-Z0-9]{2,}|((https:\\/\\/www\\.|http:\\/\\/www\\.|https:\\/\\/|http:\\/\\/)?[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})(\\.[a-zA-Z]{2,})?)|(https:\\/\\/www\\.|http:\\/\\/www\\.|https:\\/\\/|http:\\/\\/)?[a-zA-Z0-9]{2,}\\.[a-zA-Z0-9]{2,}\\.[a-zA-Z0-9]{2,}(\\.[a-zA-Z0-9]{2,})?');
    if (email && !regexp.test(email)) {
        return 'Invalid URL';
    }
    else {
        return null;
    }
}
exports.validateUrl = validateUrl;
//# sourceMappingURL=vcard-utils.js.map